import React, { useContext, useEffect, useState } from "react";
import {
    getProductProcessing,
    deleteProductProcessing,
    getRawMaterials
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { isReadonlyRoute, NaviGate } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { useLocation } from "react-router-dom";
import { EditProductProcessing } from "./iform"; 

const ProductProcessingList = () => {
    const { pathname } = useLocation();
    const readonly = isReadonlyRoute(pathname);
    const { showLoader, hideLoader } = useContext(WarehouseContext);

    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [addOrEdit, setAddOrEdit] = useState(true);
    const [rawmaterials, setRawmaterials] = useState([]);

    const [deleteID, setDeleteID] = useState("");
    const [deletemodel, showDeletemodel] = useState(false);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const rolesPerPage = 10;

    useEffect(() => {
        fetchProducts();
        fetchRawmaterials();
    }, []);

    const handledeletemodel = (ID) => {
        showDeletemodel(true);
        setDeleteID(ID);
    };

    const fetchProducts = async (page = 1, text = "") => {
        showLoader();
        try {
            const response = await getProductProcessing({ page, search: text });
            console.log("API response:", response.data);
            if (response.data && response.data.data) {
                setProducts(response.data.data);
                setTotalPages(response.data.pagination?.total_pages || 1);
            }
        } catch (error) {
            console.error("Error fetching product processing:", error);
            toast.error("Failed to fetch product processing list");
        } finally {
            hideLoader();
        }
    };

    const fetchRawmaterials = async () => {
        try {
            const response = await getRawMaterials();
            if (response.data && response.data.data) {
                setRawmaterials(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching raw materials:", error);
        }
    };

    const openAddModal = () => {
        setAddOrEdit(true);
        setSelectedProduct(null);
        setShowEditModal(true);
    };

    const openEditModal = (product) => {
        setSelectedProduct(product);
        setAddOrEdit(false);
        setShowEditModal(true);
    };

    const handleDelete = async () => {
        if (!deleteID) {
            toast.error("No product selected to delete");
            return;
        }

        try {
            await deleteProductProcessing(deleteID);
            showDeletemodel(false);
            toast.success("Product processing deleted");
            fetchProducts(currentPage);
        } catch (error) {
            console.error("Error deleting product processing:", error);
            toast.error("Error deleting product processing");
        }
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        fetchProducts(pageNumber);
    };

    const handleSearch = async (text) => {
        fetchProducts(1, text);
        setCurrentPage(1);
    };

    // Safe JSON parse function
    const safeJsonParse = (jsonString) => {
        if (!jsonString) return [];
        try {
            return JSON.parse(jsonString);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return [];
        }
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                <NaviGate />
                <div className="mb-0 d-flex justify-content-between align-items-center">
                    <h6 className="mb-0 text-uppercase" style={{ fontFamily: "poppins" }}>
                        Product Processing List
                    </h6>
                    {!readonly && (
                        <button
                            type="button"
                            onClick={openAddModal}
                            className="btn btn-primary mb-0"
                            style={{ fontFamily: "poppins" }}
                        >
                            Add Product Processing
                        </button>
                    )}
                </div>
                <hr className="mt-1" />

                <div className="card">
                    <div className="card-body">
                        <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
                            <div className="d-flex position-relative" style={{ width: "100%" }}>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Search..."
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                                <img
                                    src="/assets/images/icons/search.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        right: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        height: "18px",
                                        pointerEvents: "none",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                className="table table-striped table-sm table-bordered"
                                style={{ width: "100%", fontFamily: "poppins" }}
                            >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Product Name</th>
                                        <th>Ingredients</th>
                                        {!readonly && <th>Actions</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {products && products.length > 0 ? (
                                        products.map((prod, index) => {
                                            // Check if ingridents field exists and is a string
                                            const ingredients = prod.ingrident || safeJsonParse(prod.ingridents || "[]");

                                            return (
                                                <tr key={prod.product_processing_id || index}>
                                                    <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                                                    <td>{prod.product_name || "Unknown Product"}</td>
                                                    <td>
                                                        {Array.isArray(ingredients) && ingredients.length > 0 ? (
                                                            <table className="table table-sm table-bordered mb-0">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Raw Material</th>
                                                                        <th>Qty</th>
                                                                        <th>Unit</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {ingredients.map((item, idx) => {
                                                                        const rawMaterial = rawmaterials.find(
                                                                            (raw) => String(raw.id) === String(item.id)
                                                                        );
                                                                        return (
                                                                            <tr key={idx}>
                                                                                <td>{item.title || (rawMaterial ? rawMaterial.title : "N/A")}</td>
                                                                                <td>{item.qty}</td>
                                                                                <td>{item.unit || item.units}</td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        ) : (
                                                            <span className="text-muted">No ingredients</span>
                                                        )}
                                                    </td>

                                                    {!readonly && (
                                                        <td>
                                                            <img
                                                                src="/assets/images/icons/edit.png"
                                                                onClick={() => openEditModal(prod)}
                                                                height="16px"
                                                                alt="Edit"
                                                                style={{ cursor: "pointer" }}
                                                            />
                                                            &nbsp;&nbsp;&nbsp;
                                                            <img
                                                                src="/assets/images/icons/delete.png"
                                                                onClick={() => handledeletemodel(prod.product_processing_id)}
                                                                height="16px"
                                                                alt="Delete"
                                                                style={{ cursor: "pointer" }}
                                                            />
                                                        </td>
                                                    )}
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={!readonly ? 4 : 3} className="text-center py-3">
                                                No product processing records found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {deletemodel && <Deletemodel setShowModal={showDeletemodel} handleDelete={handleDelete} />}

            {showEditModal && (
                <EditProductProcessing
                    showModal={showEditModal}
                    setShowModal={setShowEditModal}
                    fetchProducts={fetchProducts}
                    selectedProduct={selectedProduct}
                    AddorEdit={addOrEdit}
                />
            )}
        </div>
    );
};

export default ProductProcessingList;
